import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';
import styled from 'styled-components';
import { modalsToggle } from 'actions';
import { PublicOfferInfo, SendOfferModal } from 'components/Offers';
import { useNoSelectorVehicleOfferAuctionById, usePublicOfferAmount } from 'hooks';
import { Vehicle } from 'types/vehicle';
import { ActionRow } from '../ActionRow';
import { formatCurrency } from 'utils';
import { ActionDivider } from 'pages/Admin/ViewVehicle/components/UI';

type Props = {
  vehicle: Vehicle;
};

const ControlButton = styled(Button)<{ textColor: string; color: any }>`
  border-radius: 20px;
  width: 94px;
  height: 44px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  background: ${props => props.color};
  color: ${props => props.textColor};
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background: ${props => props.color};
  }
`;

const CounterControlsWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-top: 12px;

  & > button {
    flex: 1 1 100%;
  }
`;

export const PublicOfferCounters = ({ vehicle }: Props) => {
  const dispatch = useDispatch();
  const handleCounter = () => dispatch(modalsToggle(`sendVehicleOffer-${vehicle.id}`));

  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);
  const { sellerAmount, adminAmount } = usePublicOfferAmount(offerAuction);
  const hasPublicCounters = sellerAmount > 0 || adminAmount > 0;

  if (!offerAuction) return null;

  if (!hasPublicCounters) {
    return <NoCountersInfo />;
  }

  return (
    <Fragment>
      <PublicOfferInfo offerAuction={offerAuction} />
      <CounterControlsWrapper>
        <ControlButton color={'#3994DE'} textColor={'#fff'} onClick={handleCounter}>
          {'COUNTER'}
        </ControlButton>
      </CounterControlsWrapper>

      {/* {sellerAmount > 0 && <SellerPublicOffer sellerAmount={sellerAmount} openCounterModal={handleCounter} />}
      {adminAmount > 0 && <AdminPublicOffer adminAmount={adminAmount} openCounterModal={handleCounter} />}
       */}
      <SendOfferModal maxAmount={vehicle.reserve_price} form={`sendVehicleOffer-${vehicle.id}`} vehicle={vehicle} />
    </Fragment>
  );
};

type SellerInfoProps = {
  openCounterModal: () => void;
  sellerAmount: number;
};

type AdminInfoProps = {
  openCounterModal: () => void;
  adminAmount: number;
};

const SellerPublicOffer = ({ sellerAmount, openCounterModal }: SellerInfoProps) => {
  return (
    <ActionRow
      label={`Seller counter - ${formatCurrency(sellerAmount)}`}
      buttonConfig={{
        label: 'Counter',
        handleClick: openCounterModal
      }}
    />
  );
};

const AdminPublicOffer = ({ adminAmount, openCounterModal }: AdminInfoProps) => {
  return (
    <ActionRow
      label={`AA counter - ${formatCurrency(adminAmount)}`}
      buttonConfig={{
        label: 'Update',
        handleClick: openCounterModal
      }}
    />
  );
};

const NoCountersInfo = () => {
  return <ActionRow label="No counters" buttonConfig={null} />;
};
